import type { FrameContext } from '../../cal/playable-graph';
import { TrackMixerPlayable } from './track-mixer-playable';

export class ParticleMixerPlayable extends TrackMixerPlayable {

  override evaluate (context: FrameContext): void {
  }
}
